<template>
  <div style="margin-top: 30px; padding:11px;">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      OSGB Şube Ekle
    </button>
    <br>
    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td><b> OSGB Şube Adı </b></td>
          <td><b> İşlemler </b></td>
        </tr>
        </thead>

        <tbody>
        <tr v-for="val in OsgbBranchData" v-bind:key="val.id">
          <td><b>{{val.osgbBranchName}}</b></td>
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#companyDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
            &nbsp;
            <button type="button" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="editOsgbBranch(val.id)">Düzenle</button>
            <div class="modal fade" id="companyDeleteModal" tabindex="-1" aria-labelledby="companyDeleteModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="companyDeleteModalLabel">Silme Onayı</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="OsgbBranchDelete(deleteId)">Evet, Sil</button>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" :class="{ 'wide-modal': step === 4 }"  style=" min-height: 500px; width: 750px; display: flex; flex-direction: column;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> {{ isEditing ? 'OSGB Şube Düzenle' : 'OSGB Şube Ekle' }}</h5>
            <button type="button" style="background-color: #2419d2;" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body" style="overflow-y: auto;">
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">OSGB Şube Adı</label>
              <input type="text" class="form-control" v-model="itemsOsgbBranch.osgbBranchName" placeholder="OSGB Şube Adı">
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="isEditing ? updateOsgbBranch() : createOsgbBranch()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
// @ts-nocheck

import apiClient from "@/axios";

export default {
  name: "OsgbBranch",
  data() {
    return {
      OsgbBranchData: {},
      deleteId: null,
      isEditing: false,
      itemsOsgbBranch: {},
    };
  },
  created() {
    this.getOsgbBranchData();
  },
  methods: {
    updateOsgbBranch() {
      apiClient.put(`/osgbBranch/${this.itemsOsgbBranch.id}`, this.itemsOsgbBranch).then(() => {
            this.getOsgbBranchData();
            this.isEditing = false;
          })
    },
    createOsgbBranch() {
      apiClient.post("/osgbBranch", this.itemsOsgbBranch).then(res => {
        this.getOsgbBranchData();
      })
    },
    editOsgbBranch(id) {
      apiClient.get(`/osgbBranch/${id}`).then(res => {
        this.itemsOsgbBranch = res.data;
        this.isEditing = true;
      })
    },
    getOsgbBranchData() {
      apiClient.get("/osgbBranch").then(res => {
        this.OsgbBranchData = res.data;
      });
    },
    setDeleteId(id) {
      this.deleteId = id;
    },
    OsgbBranchDelete(id) {
      apiClient.delete(`/osgbBranch/${id}`)
          .then(() => {
            this.getOsgbBranchData();
          })
          .catch(error => {
            console.error("Silme işlemi sırasında hata oluştu:", error);
          });
    }
  },
}
</script>

<style scoped>

</style>